import PropTypes from 'prop-types';
import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { onUpdate } from '../../services/hash-link-handler';
import { initI18n } from '../../services/i18n-provider';
import { getLanguage, getTranslations } from '../../services/i18n-utils';
import { I18nextProvider } from 'react-i18next';
import EnvironmentProvider from '../../components/environment-provider';
import PermissionsProvider from '../../components/permissions-provider';

const RootBase = ({ store, history, environment, children }) => (
  <EnvironmentProvider environment={environment}>
    <Provider store={store}>
      <PermissionsProvider store={store}>
        <I18nextProvider i18n={initI18n(getLanguage(), getTranslations())}>
          <Router history={history} onUpdate={onUpdate}>
            {children}
          </Router>
        </I18nextProvider>
      </PermissionsProvider>
    </Provider>
  </EnvironmentProvider>
);

RootBase.propTypes = {
  children: PropTypes.object.isRequired,
  environment: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
};

export default RootBase;



// WEBPACK FOOTER //
// ./app/containers/root-base/root-base.js